module.exports = __webpack_public_path__ + "img/img_finger_02.922d2861.png";